import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-network-host",
  "use": "app-icon-network-host-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"app-icon-network-host\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-3 0h24v24H-3z\" /><path d=\"M16 0a2 2 0 012 2v20a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zM9 13a4 4 0 100 8 4 4 0 000-8zm0 2a2 2 0 110 4 2 2 0 010-4zm4-8H5v2h8V7zm0-4H5v2h8V3z\" fill=\"#6C92FA\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol